import Layout from "./layout.molecule";

export default Layout;
